import Icon from '@/components/Icon/Icon';
import { HStack, VStack } from '@/components/Layout';
import { ProgressStepBar } from '@/components/ProgressStepBar/ProgressStepBar';
import { Text } from '@/components/Typography/Text';
import { Button } from '@/components/ui/button';
import { defaultNS, useTranslation } from '@/lib/i18n';

export const OrderStatusBanner = (props: { checkOrderLinkUrl: string }) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'pages.devices.settings.orderStatusBanner',
  });

  return (
    <VStack className="border-y bg-neutral-fill px-12 py-4 gap-2.5">
      <HStack className="gap-2 items-center">
        <Icon iconName="Truck" size={20} colorVariant="active" />
        <Text variant="h4">{t('title')}</Text>
      </HStack>
      <HStack className="gap-6 items-center">
        <ProgressStepBar
          prefixVariant="icon"
          currentStepIndex={1}
          stepLabels={[
            t('steps.ordered'),
            t('steps.inDistribution'),
            t('steps.received'),
          ]}
        />
        <HStack className="gap-3 items-center">
          <Text variant="labelSmall">{t('alreadyReceived')}</Text>
          <a href={props.checkOrderLinkUrl} target="_blank" rel="noreferrer">
            <Button variant="secondary" className="px-8 gap-2">
              {t('checkOrder')}
              <Icon iconName="ExternalLinkIcon" />
            </Button>
          </a>
        </HStack>
      </HStack>
    </VStack>
  );
};
